<div mat-dialog-content class="loading-modal">
  <o-loading [isLoading]="true" [textToDisplay]="data"></o-loading>
</div>
